<template>
  <v-application>
    <v-crud-card
      :headers="headers"
      :data="partition_valuation"
      v-model="partition_val_page"
      :num-pages="partition_val_total"
      noDelete
      :create="false"
      class="mx-2"
      @change-pagination="changePagination"
      :loading_items_table_data="data_loading"
    >
      <template #tabletop>
        <div class="mx-2 my-n4 mt-n16">
          <v-row justify="space-between">
            <v-col sm="4">
              <v-combobox
                v-model="main_store"
                :label="$t('stores')"
                outlined
                :items="stores"
                item-text="name"
                dense
                return-object
              />
            </v-col>
            <v-col sm="4">
              <v-select
                outlined
                v-model="quantity_left"
                :label="$t('quantity_left')"
                :items="quantity_lefts"
                dense
                return-object
              />
            </v-col>
            <v-col sm="4">
              <v-select
                outlined
                dense
                :items="sort_by_items"
                item-text="text"
                v-model="sort_by"
                label="Sort by"
                return-object
              />
            </v-col>
          </v-row>
        </div>
      </template>
    </v-crud-card>
  </v-application>
</template>

<script>
import Stores from "../../mixins/services";

export default {
  mixins: [Stores],
  data: () => ({
    partition_valuation: [],
    partition_val_page: 1,
    partition_val_total: 0,
    main_store: {
      name: "All stores",
      _id: "",
    },
    search: "",
    quantity_left: { text: "All", value: "all" },
    quantity_lefts: [
      { text: "All", value: "all" },
      { text: "Zero", value: "zero" },
      { text: "Not zero", value: "not_zero" },
    ],
    sort_by: { text: "None" },
    sort_by_items: [
      { text: "None" },
      { text: "Quantity left", value: "quantity_left" },
      { text: "Date", value: "date" },
      { text: "Id", value: "_id" },
    ],
  }),
  computed: {
    headers() {
      return [
        { value: "supplier_name", text: this.$t("name") , available: true},
        { value: "service_name", text: this.$t("service_name"), available: true },
        { value: "good_name", text: this.$t("good_name") , available: true},
        { value: "quantity", text: this.$t("quantity"), available: true },
        { value: "quantity_left", text: this.$t("quantity_left") , available: true},
        { value: "p_order", text: this.$t("p_order") , available: true},
      ];
    },
  },
  methods: {
    async getData() {
      this.data_loading = true;
      const link = `inventory/partiation/valuation/${this.$store.state.partition_valuation_by_supplier}`;
      let body = {
        limit: 10,
        page: this.partition_val_page,
        search: this.search,
        service_id: this.main_store._id,
        quantity_left: this.quantity_left.value,
      };
      if (this.sort_by !== "") {
        body = Object.assign({ sort_by: this.sort_by.value }, body);
      }
      const result = await this.$communicator.postMethod2(link, body);
      if (result) this.data_loading = false;
      this.partition_valuation = result.data.data.data;
      this.partition_val_total = Math.ceil(result.data.data.total / 10);
    },
    changePagination(page) {
      this.partition_val_page = page;
    },
  },
  watch: {
    main_store() {
      this.getData();
    },
    sort_by() {
      this.getData();
    },
    quantity_left() {
      this.getData();
    },
    partition_val_page() {
      this.getData();
    },
  },
  beforeMount() {
    this.getData();
  },
};
</script>

<style scoped>
</style>
